import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { jsx } from '@emotion/react';
import { TouchTarget } from '../TouchTarget/TouchTarget.js';

const baseStyles = () => ({
  fontFamily: "default",
  position: "relative",
  background: "none",
  color: "foreground.action.strong",
  border: "none",
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  cursor: "pointer",
  transition: _ref => {
    let {
      transitions
    } = _ref;
    return transition(transitions.default, "color", "box-shadow");
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  "&:hover": {
    color: "foreground.action.strong.hover"
  },
  "&:active": {
    color: "foreground.action.strong.active"
  },
  "&:focus-visible": {
    outline: "none",
    boxShadow: "focus"
  }
});
const variantStyles = {
  icon: {
    borderRadius: "sm",
    lineHeight: 0
  },
  link: {
    textDecoration: "underline dotted 0.0625rem",
    textDecorationColor: "foreground.action.strong",
    textDecorationSkipInk: "none",
    textUnderlineOffset: "0.25em",
    textUnderlinePosition: "auto",
    borderBottom: "none",
    cursor: "pointer",
    fontSize: "inherit",
    "&:hover": {
      textDecorationColor: "foreground.action.strong.hover"
    },
    "&:active": {
      textDecorationColor: "foreground.action.strong.active"
    }
  }
};
const ThemedButton = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480"
} : {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480",
  label: "ThemedButton"
})(baseStyles, _ref2 => {
  let {
    variant = "icon"
  } = _ref2;
  return variantStyles[variant];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const ThemedInfoButton = TouchTarget.withComponent(ThemedButton, process.env.NODE_ENV === "production" ? {
  target: "e153n8481"
} : {
  target: "e153n8481",
  label: "ThemedInfoButton"
});
const InfoButton = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    variant = "icon",
    as,
    ...props
  } = _ref3;
  const component = jsx(ThemedInfoButton, _extends({
    as: as,
    ref: forwardedRef,
    variant: variant
  }, props));
  return component;
});
const INFO_BUTTON_VARIANTS = ["icon", "link"];

export { INFO_BUTTON_VARIANTS, InfoButton };
